import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const tagSelectorBasicClassNames = "group flex items-center min-w-0 w-80 border transition-[background-color,border-color,color,box-shadow]", tagSelectorTriggerVariants = tv({
  base: `
    ${tagSelectorBasicClassNames}
    text-(--gray-text-2) outline-none rounded-md placeholder:text-(--gray-primary-1-alpha)
    aria-[disabled=true]:bg-(--gray-bg-2-alpha)
  `,
  variants: {
    size: {
      sm: "px-1",
      default: "px-2 py-1",
      lg: "px-2 py-1"
    },
    focus: { default: "", focus: "" },
    variant: {
      default: `
        bg-(--white) border-(--gray-tag-3-alpha) aria-invalid:border-(--red-6-alpha) focus:ring-[1px]
               focus:border-(--border-3-alpha)                 focus:ring-(--border-1-alpha)
        aria-invalid:focus:border-(--red-6-alpha) aria-invalid:focus:ring-(--red-3-alpha)
      `,
      filled: `
        border-transparent bg-(--tag-1-alpha) aria-invalid:bg-(--red-3-alpha)
                     hover:bg-(--tag-2-alpha) aria-invalid:hover:bg-(--red-4-alpha)
      `,
      ghost: "border-transparent hover:bg-(--tag-1-alpha) aria-invalid:hover:bg-(--red-3-alpha)"
    },
    multiple: { default: "", multiple: "" }
  },
  compoundVariants: [
    { size: "sm", multiple: "default", class: "h-6" },
    { size: "default", multiple: "default", class: "h-9" },
    { size: "lg", multiple: "default", class: "h-10" },
    { size: "sm", multiple: "multiple", class: "min-h-6" },
    { size: "default", multiple: "multiple", class: "min-h-9" },
    { size: "lg", multiple: "multiple", class: "min-h-10" }
  ],
  defaultVariants: {
    size: "default",
    focus: "default",
    variant: "default",
    multiple: "default"
  }
}), tagSelectorContainerVariants = tv({
  base: "grow flex flex-wrap items-center h-full overflow-hidden ",
  variants: {
    size: {
      sm: "gap-0.5",
      default: "gap-1",
      lg: "gap-1"
    }
  },
  defaultVariants: {
    size: "default"
  }
}), tagSelectorPlaceholderVariants = tv({
  base: "select-none text-(--gray-primary-1-alpha) whitespace-nowrap",
  variants: {
    size: {
      sm: "text-sm",
      default: "text-base",
      lg: "text-lg"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
export {
  tagSelectorContainerVariants,
  tagSelectorPlaceholderVariants,
  tagSelectorTriggerVariants
};
//# sourceMappingURL=index.js.map
